import React, { useEffect, useState, useRef } from "react";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Divider,
  IconButton,
  Fab,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useSelector, useDispatch } from "react-redux";
import * as virActions from "src/actions/virActions";
import * as appActions from "../../actions/appActions";

import _ from "lodash";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import getBrandFromUrl from "src/utils/getBrandFromUrl";

const VirExpireAlarm = () => {
  const athenaSource = useSelector((state) => state.vir.athenaSource.source);
  const [letSessionExpire, setLetSessionExpire] = useState(false);
  const [willExpire, setWillExpire] = useState(false);
  const brand = getBrandFromUrl();

  const vir = useSelector((state) => state.vir);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const sessionTrackerRef = useRef(null);
  const isMountedRef = useRef(true);

  const onExtendSession = () => {
    dispatch(
      appActions.createToast({
        type: "success",
        message: "Your session is extend 5 more minutes.",
      })
    );
    dispatch(virActions.extendSession());
    setWillExpire(false);
  };

  useEffect(() => {
    isMountedRef.current = true;

    setLetSessionExpire(false);

    if (sessionTrackerRef.current) {
      clearInterval(sessionTrackerRef.current);
    }

    sessionTrackerRef.current = setInterval(() => {
      const sessionExpiry = _.get(vir, "athenaAuth.expires", moment().subtract(0, "m").unix());

      if (moment().isAfter(moment.unix(sessionExpiry))) {
        if (athenaSource === "web") {
          dispatch(
            appActions.createToast({
              type: "error",
              message: "Your session is expired.",
            })
          );
          setLetSessionExpire(true);
          dispatch(virActions.virLogout());
        } else {
          setLetSessionExpire(true);
          navigate("/vehicleincidents/expire" + `?brand=${brand}`, { replace: true });
        }
      }

      const isExpiring = moment().add(1, "m").isAfter(moment.unix(sessionExpiry));

      if (isMountedRef.current) {
        setWillExpire(isExpiring);
      }
    }, 10000);

    return () => {
      isMountedRef.current = false;
      if (sessionTrackerRef.current) {
        clearInterval(sessionTrackerRef.current);
      }
    };
  }, [vir.athenaAuth.expires, dispatch]);

  return (
    <Dialog open={willExpire && !letSessionExpire}>
      <DialogTitle style={{ textAlign: "center" }}>
        <IconButton aria-label="close" onClick={() => setLetSessionExpire(true)}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>Your session will expire in 1 minute.</DialogContent>
      <DialogActions>
        <Divider />
        <Grid spacing={1} container direction="row" justifyContent="center">
          <Grid container item xs={12} justifyContent="center">
            <Fab color="primary" variant="extended" onClick={onExtendSession}>
              Extend My Session
            </Fab>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default VirExpireAlarm;
